import { provideTransloco, TranslocoModule, TranslocoPipe } from '@jsverse/transloco';
import { NgModule } from '@angular/core';
import { TranslocoHttpLoader } from './transloco-loader';
import { environment } from './../environments/environment';
import { FormModalComponent } from './shared/composants/form-utils/forms/form-modal/form-modal.component';
import { InputDateComponent } from './shared/composants/form-utils/inputs/input-date/input-date.component';
import { InputNumberComponent } from './shared/composants/form-utils/inputs/input-number/input-number.component';
import { InputSelectComponent } from './shared/composants/form-utils/inputs/input-select/input-select.component';
import { MatDialogTitle } from '@angular/material/dialog';
import { AsyncPipe, NgIf } from '@angular/common';
import { InputAutocompleteComponent } from './shared/composants/form-utils/inputs/input-autocomplete/input-autocomplete.component';
import { InputTextComponent } from './shared/composants/form-utils/inputs/input-text/input-text.component';
import { MatIcon } from '@angular/material/icon';

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['fr'],
        defaultLang: 'fr',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader,
    }),
  ],
  imports: [
    FormModalComponent,
    InputDateComponent,
    InputNumberComponent,
    InputSelectComponent,
    MatDialogTitle,
    MatIcon,
    NgIf,
    InputAutocompleteComponent,
    AsyncPipe,
    InputTextComponent,
    InputDateComponent,
    TranslocoPipe,
  ],
})
export class TranslocoRootModule {}
